export default __webpack_public_path__ + "static/media/4.fd09cd81.JPG";